import { useQuery, useMutation, UseMutationOptions } from "react-query";
import { AxiosRequestConfig } from "axios";
import axiosInstance from "./AxiosInstance";

export const useApi = <T>(
  key: string,
  url: string,
  method: "get"
) => {
  const fetchData = async () => {
    const response = await axiosInstance({ method, url });
    return (await response.data) as T;
  };

  return useQuery<T>(key, fetchData);
};

export const useApiMutation = <T, U>(
  url: string,
  method: "get" | "post" | "put" | "delete" | "patch",
  options?: UseMutationOptions<T, Error, { data: U; params?: Record<string, any>; url?: string; extraPrams?: any }>
) => {

  const mutationFn = async (variables: { data: U; params?: Record<string, any>; url?: string, extraPrams?: any }) => {
    const isImpersonated = (window as any).Liferay.ThemeDisplay.isImpersonated();
    const doAsUserIdEncoded = (window as any).Liferay.ThemeDisplay.getDoAsUserIdEncoded();

    const updateParams = isImpersonated ? { ...variables.params, doAsUserId: doAsUserIdEncoded } : variables.params;
    const axiosConfig: AxiosRequestConfig = {
      method,
      url: variables?.url ? url + variables?.url : url,
      data: variables.data,
      params: updateParams, // Pass query parameters as params
      headers: {
        ...(variables.data instanceof FormData ? { "Content-Type": "multipart/form-data" } : { "Content-Type": "application/json" }), // Set content type if not FormData
      },
    };
    const response = await axiosInstance(axiosConfig);
    return response.data as T;
  };

  return useMutation<T, Error, { data: U; params?: Record<string, any>; url?: string, extraPrams?: {} }>(mutationFn, {
    mutationKey: [url, method],
    ...options,
  });
};